import { create } from "zustand";

type RefreshStore = {
  refreshKey: number;
  triggerRefresh: () => void;
};

const useRefreshStore = create<RefreshStore>((set) => ({
  refreshKey: 0,
  triggerRefresh: () => set((state) => ({ refreshKey: state.refreshKey + 1 }))
}));

export default useRefreshStore;
